module.exports = __webpack_public_path__ + "img/savePictureWhite.b88204a7.svg";